import React from "react";
import { Skeleton, Flex, Grid, Tabs, Select, Stack } from "@mantine/core";
import { Section } from "../Container/Section";
import { SectionTitleWithExp } from "../customTypo/SectionTitleWithExp";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import colorsCustom from "../../designTokens/colorsCustom";

export const CardGridSkeleton = ({ isMobile, title }) => {
	const renderCardListSkeleton = () => (
		<Flex direction="column" gap={16}>
			{/* 필터 영역 */}
			<Flex direction="column" gap={8}>
				<Flex justify="space-between" align="center">
					<Skeleton height={20} width={150} />
					<Skeleton height={32} width={120} />
				</Flex>
				<Skeleton height={14} width="80%" />
			</Flex>
			
			{/* 카드 리스트 */}
			<Stack gap={8}>
				{[1, 2, 3, 4, 5].map((index) => (
					<Flex
						key={index}
						direction="column"
						gap={8}
						p={12}
						style={{
							border: "1px solid #e0e0e0",
							borderRadius: "8px",
						}}
					>
						{/* 카드 헤더 */}
						<Flex justify="space-between" align="center">
							<Skeleton height={12} width={80} />
							<Skeleton height={20} width={20} circle />
						</Flex>
						
						{/* 카드 본문 */}
						<Stack gap={4}>
							<Skeleton height={16} width="100%" />
							<Skeleton height={16} width="80%" />
							<Skeleton height={16} width="60%" />
						</Stack>
						
						{/* 메트릭 */}
						<Flex justify="space-between" align="center">
							<Flex gap={16}>
								<Skeleton height={14} width={50} />
								<Skeleton height={14} width={40} />
								<Skeleton height={14} width={40} />
								<Skeleton height={14} width={50} />
							</Flex>
						</Flex>
					</Flex>
				))}
			</Stack>
		</Flex>
	);

	return (
		<Section>
			<SectionTitleWithExp
				title={title}
				isMobile={isMobile}
			/>
			<CardContainerRetro
				p={isMobile ? 16 : 24}
				bg={colorsCustom.paper}
				weight="bold"
				rd={16}
			>
				<Flex direction="column" gap={24}>
					{/* 상단 필터 컨트롤 */}
					<Flex direction="column" gap={16}>
						<Flex justify="space-between" align="center" wrap="wrap" gap={8}>
							<Skeleton height={32} width={120} />
							{isMobile && (
								<Flex gap={8}>
									<Skeleton height={32} width={80} />
									<Skeleton height={32} width={80} />
								</Flex>
							)}
						</Flex>
					</Flex>

					{isMobile ? (
						<Tabs defaultValue="views">
							<Tabs.List>
								<Tabs.Tab value="views">
									<Skeleton height={16} width={60} />
								</Tabs.Tab>
								<Tabs.Tab value="rate">
									<Skeleton height={16} width={80} />
								</Tabs.Tab>
								<Tabs.Tab value="amount">
									<Skeleton height={16} width={70} />
								</Tabs.Tab>
							</Tabs.List>
							<Tabs.Panel value="views" pt="md">
								{renderCardListSkeleton()}
							</Tabs.Panel>
						</Tabs>
					) : (
						<Grid>
							<Grid.Col span={4}>
								{renderCardListSkeleton()}
							</Grid.Col>
							<Grid.Col span={4}>
								{renderCardListSkeleton()}
							</Grid.Col>
							<Grid.Col span={4}>
								{renderCardListSkeleton()}
							</Grid.Col>
						</Grid>
					)}
				</Flex>
			</CardContainerRetro>
		</Section>
	);
}; 